import React from 'react'
import { styled } from '@mui/material/styles'

export interface IOwnProps {
  className?: string
}

export type IProps = IOwnProps

const Placeholder:React.FC<IProps> = (props) => {
  const {
    className,
  } = props

  return (
    <div className={className} />
  )
}

export default styled(Placeholder)(({ theme }) => ({
  position: 'relative',
  minHeight: 50,
  backgroundColor: theme.palette.whiteColor.main,
  '&::before': {
    content: '" "',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: '50%',
    zIndex: 1,
    width: '500%',
    marginLeft: '-250%',
    animation: 'placeholder .8s linear infinite',
    background: `linear-gradient(120deg, ${theme.palette.whiteColor.main} 46%, ${theme.palette.secondary.main} 50%, ${theme.palette.whiteColor.main} 54%) 50% 50%`,

    '@keyframes placeholder': {
      '0%': {
        transform: 'translate3d(-30%, 0, 0)',
      },
      '100%': {
        transform: 'translate3d(30%, 0, 0)',
      },
    },
  },
}))
